import { FC, type HTMLAttributeAnchorTarget } from 'react';

// ========================= 组件 =========================
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Mousewheel } from 'swiper/modules'

// ========================= 数据交互 =========================

// ========================= 全局数据 =========================

// ========================= 常量 =========================

// ========================= 工具 =========================

// ========================= 样式 =========================
import styles from './index.module.css';
import 'swiper/css';
import 'swiper/css/pagination';
import Link from '../link';
import { useRouter } from 'next/router';

// ========================= 变量 =========================

// ========================= 类型 =========================

interface PopularEventsItems {
    id: number;
    title: string;
    articleAbstract: string;
    photoUrl: string;
    startTime?: string;
    endTime?: string;
    status?: number;
}

interface PopularEventsProps {
    items?: PopularEventsItems[];
    target?: HTMLAttributeAnchorTarget;
    href: string | ((id: number) => string);
    onClick?: (id: number) => void;
}

const PopularEvents: FC<PopularEventsProps> = ({ items = [], target, href, onClick }) => {

    const { locale = 'zh' } = useRouter();

    return (
        <div className={styles['popular-events-container']}>
            <Swiper
                slidesPerView={1}
                spaceBetween={30}
                loop={true}
                grabCursor={true} // 鼠标移动到slide上时变成手型
                modules={[Pagination, Autoplay, Mousewheel]}
                autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true
                }}
                pagination={{
                    clickable: true,
                    el: `.${styles['swiper-pagination']}`,
                    bulletClass: styles['swiper-pagination-bullet'],
                    bulletActiveClass: styles['swiper-pagination-bullet-active']
                }}
                mousewheel={{
                    forceToAxis: true,
                }}
                className={styles['popular-events-swiper']}
            >

                {
                    items.map((item) => (
                        <SwiperSlide
                            key={item.id}
                            onClick={() => onClick && onClick(item.id)}
                        >
                            <Link href={typeof href === 'string' ? href : href(item.id)} target={target} locale={locale}>
                                <div className={styles['popular-events-item']}>
                                    <div className={styles['popular-events-image-wrapper']}>
                                        <img
                                            className={styles['popular-events-image']}
                                            src={item.photoUrl}
                                            alt=""
                                        />
                                    </div>
                                    <div className={styles['popular-events-content']}>
                                        <h3>{item.title}</h3>
                                        <p>{item.articleAbstract}</p>
                                        <button className={styles['slide-button']}>立即参与</button>
                                    </div>

                                </div>
                            </Link>
                        </SwiperSlide>
                    ))
                }
            </Swiper>
            <div className={styles['swiper-pagination']}></div>
        </div>
    );
}
export default PopularEvents;